import { put, call } from 'redux-saga/effects';
import * as invoiceActions from '../actions/invoiceActions';

export function* getMeInvoices(api, action) {
  const response = yield call(api.getMeInvoices);
  if (response.status == 200) {
    yield put(invoiceActions.saveMeInvoices(response.data));
  }
}
